module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_8023.205ad5b4.png";